module.exports = __webpack_public_path__ + "components/country-flag/static/bj-c112c2a6aab1dee3d78dc7ca8166e643.svg";